import { Component, Input, EventEmitter, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services */
import { DevicesService, StateService, AppService } from '@services';

/*Models */
import { DailyQuality, Device, GraphQuality } from '@models';

/*Plugins */

/*Plugins */
import { IMyDrpOptions, IMyDateRangeModel } from 'mydaterangepicker';
import * as moment from 'moment';

/*Config*/
import { CONFIG } from '@config';

@Component({
	selector: 'app-report-quality',
	templateUrl: './report-quality.component.html',
	styleUrls: ['./report-quality.component.scss']
})

export class ReportQualityComponent implements OnInit {

	
	myDateRangePickerOptions: IMyDrpOptions = {
		dateFormat: 'dd.mm.yyyy',
		selectBeginDateTxt: 'Выберите начало периода',
		selectEndDateTxt: 'Выберите конец периода',
		showSelectDateText: true,
		monthSelector: true,
		showClearDateRangeBtn: false,
		editableDateRangeField: false,
		openSelectorOnInputClick: true,
		showClearBtn: false,
		showApplyBtn: false,
		yearSelector: false,
		disableSince: { year: 0, month: 0, day: 0 },
		disableUntil: { year: 0, month: 0, day: 0 },
		dayLabels: CONFIG.dayLabels,
		monthLabels: CONFIG.monthLabels
	  };
	  modelDateRange;

	  graphData: GraphQuality
  	private ngUnsubscribe: Subject<void> = new Subject<void>();
  	private currentDevice: Device;
	currentDay: number;
	ifLoadDailyQuality = true;
	ifLoadGraphQuality = false;
	dailyQuality: DailyQuality;
	
  	constructor(private stateService: StateService, private devicesService: DevicesService){}

	ngOnInit() {
		this.currentDay = moment().unix();

		this.stateService.currentDeviceObservable
			.takeUntil(this.ngUnsubscribe)
			.subscribe(device => {
				this.currentDevice = device;
				this.initDateRange();
				console.log(this.currentDevice)
				this.getDailyQuality()
				
			});
	}


	initDateRange() {
		const date = new Date();
		const copy = this.getCopyOfOptions();
	
		const dateTomorrow = this.addDays(date, 1);
	
		copy.disableSince = {
		  year: dateTomorrow.getFullYear(),
		  month: dateTomorrow.getMonth() + 1,
		  day: dateTomorrow.getDate(),
		};
	
		copy.disableUntil = {
		  year: date.getFullYear() - 1,
		  month: date.getMonth() + 1,
		  day: date.getDate() - 1
		};
	
		this.myDateRangePickerOptions = copy;
		this.setInitialDate()
		
	
		
		this.onDateRangeChanged();
	}
	setInitialDate (){
		const date = new Date();
		const firstDayMonth = new Date(date.getFullYear(), date.getMonth(), 1);
		this.modelDateRange = {
			beginDate: {
			  year: firstDayMonth.getFullYear(),
			  month: firstDayMonth.getMonth() + 1,
			  day: firstDayMonth.getDate(),
			},
			endDate: {
			  year: date.getFullYear(),
			  month: date.getMonth() + 1,
			  day: date.getDate(),
			}
		  };
	}
	

	getCopyOfOptions(): IMyDrpOptions {
		return JSON.parse(JSON.stringify(this.myDateRangePickerOptions));
	}
	
	addDays(date, days) {
		const result = new Date(date);
		result.setDate(result.getDate() + days);
		return result;
	}

	onDateRangeChanged(event?: IMyDateRangeModel) {
		if (event) {
		  this.modelDateRange.beginDate = event.beginDate;
		  this.modelDateRange.endDate = event.endDate;
		}
	
		const fromMoment = moment.utc({
		  year: this.modelDateRange.beginDate.year,
		  month: this.modelDateRange.beginDate.month - 1,
		  date: this.modelDateRange.beginDate.day
		});
	
		const toMoment = moment.utc({
		  year: this.modelDateRange.endDate.year,
		  month: this.modelDateRange.endDate.month - 1,
		  date: this.modelDateRange.endDate.day
		});
	
		const from = fromMoment.startOf('day').unix()-(24*60*60);
		const to = toMoment.startOf('day').unix();

		let dayDiff = Math.abs(fromMoment.diff(toMoment, 'days'))+1;
		
		this.getPeriodQuality(from, to, dayDiff);
	}

  	getDailyQuality(){
		this.devicesService.getDailyQuality(this.currentDevice.id,this.currentDevice.provider,this.currentDay)
			.subscribe(response => {
				this.dailyQuality = response;
				console.log(response)
				this.ifLoadDailyQuality = false;
				
			}, errors => {
				console.log(errors);
				this.ifLoadDailyQuality = false;
			});
	}

	getPeriodQuality(fromUnix: number, toUnix: number, dayDiff: number){
		if(this.ifLoadGraphQuality){
			return;
		}
		this.ifLoadGraphQuality = true;

		this.devicesService.getPeriodQuality(this.currentDevice.id,this.currentDevice.provider,fromUnix,toUnix,dayDiff<=30)
			.subscribe(response => {
	 
	  			this.graphData = response;
				console.log(response)
				
				this.ifLoadGraphQuality = false;
			}, errors => {
				console.log(errors);
				this.ifLoadGraphQuality = false;
				
			});
		console.log(fromUnix,toUnix)
	}

	selectDate(type: string){
		if(this.ifLoadGraphQuality){
			return;
		}
		if(type==="week"){
			const date = new Date();
			const firstDayWeek = this.getMonday(new Date()); 
			this.modelDateRange = {
				beginDate: {
				  year: firstDayWeek.getFullYear(),
				  month: firstDayWeek.getMonth() + 1,
				  day: firstDayWeek.getDate(),
				},
				endDate: {
				  year: date.getFullYear(),
				  month: date.getMonth() + 1,
				  day: date.getDate(),
				}
			  };
		}else if(type ==="month"){
			this.setInitialDate()
		} else if(type ==="year"){

			const date = new Date();
			const firstDayWeek = this.getMonday(new Date()); 
			this.modelDateRange = {
				beginDate: {
				  year: firstDayWeek.getFullYear(),
				  month: 1,
				  day: 1,
				},
				endDate: {
				  year: date.getFullYear(),
				  month: date.getMonth() + 1,
				  day: date.getDate(),
				}
			  };
			
		}
		this.onDateRangeChanged()
	}

	 getMonday(d) {
		d = new Date(d);
		var day = d.getDay(),
			diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
		return new Date(d.setDate(diff));
	  }
	  
	  // Mon Nov 08 2010
}





// WEBPACK FOOTER //
// ./src/app/view/components/report-quality/report-quality.component.ts